import React, {useState, useEffect, useRef} from "react";
import {Container, Row, Col, Card, CardBody} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Avatar, Button, DatePicker, Pagination, Tag} from "antd";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.css";
import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import PlantaoModal from "../dashboard/calender/plantaoModal";
import AuthService from "../login/AuthService";
import SelectPlantonistaModal from "./SelectPlantonistaModal";
import moment from "moment";
import "moment/locale/pt-br";
import locale from "antd/es/date-picker/locale/pt_BR"; // Importando o locale do antd
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Importando o CSS do skeleton loader
// import './assets/css/Duty.css';
import dayjs from 'dayjs';
import HospitalSearch from "../hospital/HospitalSearch";
import Swal from "sweetalert2";
import {formatDuration, intervalToDuration} from "date-fns";
import {ptBR} from "date-fns/locale";
import ImportModal from "../import/ImportModal";
import CustomPagination from "../util/CustomPagination";
import UsersSearch from "../dashboard/calender/UsersSearch";
import ScalePostingSelectedModal from "../scale/ScalePostingSelectedModal";
import DutyMigrateUserModal from "./DutyMigrateUserModal";
import LoadingScreen from "../util/LoadingScreen";
import PlantaoPersonalModal from "../dashboard/calender/plantaoPersonalModal";

const {RangePicker} = DatePicker;


moment.locale('pt-br');

const Duty = () => {
    document.title = "Cadastro Plantão | Plantão Rápido";
    const refUserSearch = useRef(null);
    const [loadingPage, setLoadingPage] = useState(false);
    const [showSelectedModal, setShowSelectedModal] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [arrayDutySelected, setArrayDutySelected] = useState(null);


    const user = AuthService.getUserData();


    const validedManager = (types = [], checkManager = false) => {
        const selectedCompany = user?.companies?.find(c => c.selected === 1) || user?.companies?.[0];
        return selectedCompany?.managers?.length > 0 ;

    };

    const checkManager = validedManager();

    const oneMonthFromNow = moment().add(1, 'month');
    const [showImportModal, setShowImportModal] = useState(false);
    const [docTypeModalData, setDocTypeModalData] = useState(null);
    const [users, setUsers] = useState(AuthService.getUserData());
    const [duties, setDuties] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalPersonalVisible, setModalPersonalVisible] = useState(false);
    const [selectPlantonistaVisible, setSelectPlantonistaVisible] = useState(false);
    const [selectedDuty, setSelectedDuty] = useState(null);
    const today = dayjs();
    const endOfNextMonth = dayjs().add(1, 'month').endOf('month');

    const [filters, setFilters] = useState({
        dateRange: [today, endOfNextMonth],
        datestart: today.format("YYYY-MM-DD"),
        dateend: endOfNextMonth.format("YYYY-MM-DD"),
        status: "",
        hospital: "",
    });
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});


    const handleSearchFiltersChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };


    const fetchDuties = async (page = 1, isExport = false, pdf = false) => {
        if (!isExport) {
            setLoading(true);
        }

        try {
            let firstDay = null;
            let lastDay = null;
            if (pdf) {
                const {value: selectedMonth} = await Swal.fire({
                    title: 'Selecione o período',
                    input: 'month',
                    inputLabel: 'Escolha o mês e ano para exportação',
                    inputAttributes: {
                        required: 'true'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Exportar PDF',
                    cancelButtonText: 'Cancelar',
                    inputValue: new Date().toISOString().slice(0, 7),
                    inputValidator: (value) => {
                        if (!value) return 'Você precisa selecionar um mês e ano';
                    }
                });

                if (!selectedMonth) return; // Cancelado

                // Converte "2024-03" para range
                const [year, month] = selectedMonth.split("-");
                firstDay = `${year}-${month}-01`;
                lastDay = new Date(Number(year), Number(month), 0).toISOString().split("T")[0];

            }

            if (isExport) {
                setLoadingPage(true);
            }


            // Define o responseType baseado no tipo de exportação
            const responseType = isExport ? 'blob' : 'json';

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}duty/duty-record`,
                {
                    pagination: pagination.pageSize,
                    page: page,
                    status: filters.status,
                    hospital: filters.hospital,
                    datestart: pdf ? firstDay : filters?.datestart,
                    dateend: pdf ? lastDay : filters?.dateend,
                    isExport: isExport,
                    user: filters.user_id,
                    ...(user.users_type_id === 1 && {logged_in_user: true}),
                    idPdf: pdf // Adiciona o parâmetro PDF para exportação
                },
                true,
                responseType
            );

            if (isExport || pdf) {

                // Determina o tipo de arquivo com base no pdf flag
                const fileType = pdf
                    ? 'application/pdf'
                    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

                const fileExtension = pdf ? 'pdf' : 'xlsx';

                // Cria o blob do arquivo
                const blob = new Blob([response], {type: fileType});
                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `duties_export_${new Date().toISOString().split('T')[0]}.${fileExtension}`;
                link.click();
                URL.revokeObjectURL(downloadUrl);
            } else {
                // Se não for exportação, trata a resposta JSON normalmente
                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
                setDuties(data || []);
                setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        setFilters((prev) => {
            // Apenas define se não houver datas ainda
            if (!prev.datestart && !prev.dateend) {
                return {
                    ...prev,
                    dateRange: [today, endOfNextMonth],
                    datestart: today.format("YYYY-MM-DD"),
                    dateend: endOfNextMonth.format("YYYY-MM-DD"),
                };
            }
            return prev;
        });

        fetchDuties(1, false, false);
    }, []);


    const handleDelete = async (dutyId) => {
        try {
            const result = await Swal.fire({
                title: 'Tem certeza?',
                text: "Você não poderá reverter isso!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, deletar!',
                cancelButtonText: 'Cancelar'
            });

            if (result.isConfirmed) {
                await ApiService.send("delete", process.env.REACT_APP_URL_API + "duty/delete", {id: dutyId});
                setDuties(duties.filter(duty => duty.id !== dutyId)); // Remove the duty from the list
                Swal.fire({
                    title: 'Sucesso!',
                    text: 'Plantão deletado com sucesso.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    const handleModalOpen = (duty = null) => {
        setSelectedDuty(duty);
        setModalVisible(true);
    };

    const handleModalPersonalOpen = (duty = null) => {
        setSelectedDuty(duty);
        setModalPersonalVisible(true);
    };

    const handleModalClose = (save = false) => {
        setModalVisible(false);
        setSelectedDuty(null);
        if (save) {
            fetchDuties(pagination.current, false, false); // Refresh the list after modal is closed
        }
    };

    const handleModalPersonalClose = (save = false) => {
        setModalPersonalVisible(false);
        setSelectedDuty(null);
        if (save) {
            fetchDuties(pagination.current, false, false); // Refresh the list after modal is closed
        }
    };

    const handleSelectPlantonistaOpen = (duty) => {

        setSelectedDuty(duty);
        setSelectPlantonistaVisible(true);
    };

    const handleSelectPlantonistaClose = (save = false) => {
        setSelectPlantonistaVisible(false);
        setSelectedDuty(null);
        if (save) {
            fetchDuties(pagination.current, false, false);
        }
    };


    const handleFilterChange = (changedFilters) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            ...changedFilters,
        }));
    };


    const handleClearFilters = () => {
        setFilters({
            dateRange: "",
            datestart: null,
            dateend: null,
            status: "",
            hospital: "",
        });
    };

    const onHospitalSelect = (hospital) => {
        if (hospital && hospital.value) {
            // Somente atualiza o filtro se o hospital tiver um ID válido
            handleFilterChange({hospital: hospital.value});
        } else {
            // Se nenhum hospital for selecionado (hospital é null), limpe o filtro
            handleFilterChange({hospital: null});
        }
    };


    const calculateDuration = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const duration = intervalToDuration({start: startDate, end: endDate});
        return formatDuration(duration, {format: ["hours", "minutes"], locale: ptBR});
    };

    const handleImport = () => {
        setShowImportModal(true);
    };

    const handleHideImportModal = () => {
        setShowImportModal(false);
    };

    const fetchArraySelect = async (filtersStatus = false) => {
        setLoading(true); // inicia o loading aqui, se estiver usando

        try {

            const params = {
                idArray: selectedIds,
                isAll: true
            };

            // Se filtros forem passados, adiciona os filtros no params
            if (filtersStatus) {

                params.status = filters.status || null;
                params.hospital = filters.hospital || null;
                params.datestart = filters?.datestart || null;
                params.dateend = filters?.dateend || null;
                params.isExport = false;
                params.per_page = 1000;
                params.user = filters?.user_id || null;
                params.idArray = null;
                if (user.users_type_id === 1) {
                    params.logged_in_user = true;
                }
            }

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}duty/duty-record`,
                params,
                true
            );

            const {data} = ApiService.handleApiResponse(response);
            setArrayDutySelected(data || []);

            if (data.length > 0) {
                setShowSelectedModal(true);
            } else {
                Swal.fire("Erro!", "Nenhuma escala encontrada!", "error");
            }

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleMigrateUser = () => {
        Swal.fire({
            title: "Como deseja migrar os plantões?",
            text: "Você pode migrar os plantões selecionados ou aplicar os filtros acima para definir quais migrar.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Selecionados",
            cancelButtonText: "Pelo Filtro",
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                handleDutyMigrateSelectedModal(); // migrar selecionados
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                fetchArraySelect(true); // migrar pelo filtro
            }
        });
    };

    const handleDutyMigrateSelectedModal = () => {
        if (selectedIds.length > 0) {
            fetchArraySelect();
        } else {
            Swal.fire("Erro!", "Nenhuma escala selecionada!", "error");
        }
    }

    const handleSelectedModalClose = (save = false) => {
        setShowSelectedModal(false)

        if (save) {
            fetchDuties(pagination.current, false, false);
        }
    }

    const handleCheckboxChange = (id) => {
        setSelectedIds((prevSelected) => {
            if (prevSelected.includes(id)) {
                return prevSelected.filter((itemId) => itemId !== id);
            } else {
                return [...prevSelected, id];
            }
        });
    };

    return (
        <React.Fragment>
            {loadingPage && <LoadingScreen/>}
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Cadastro" pageTitle="Plantão"/>
                    <Row className="g-4 mb-4">
                        <div className="col-sm-12">
                            <div className="button-group">
                                {(checkManager || user?.users_type_id === 2) && (
                                    <>
                                        <button type="button" className="btn btn-outline-primary"
                                                onClick={() => handleModalOpen()}>
                                            <i className="fa fa-plus"></i> Novo Plantão
                                        </button>

                                        <button type="button" className="btn btn-outline-dark btn-s "
                                                onClick={() => handleImport()}>
                                            <i className="fa fa-upload"></i> Importar
                                        </button>
                                    </>
                                )}
                                {user?.users_type_id === 1 && (
                                    <button type="button" className="btn btn-primary"
                                            onClick={() => handleModalPersonalOpen()}>
                                        <i className="fa fa-calendar"></i> Novo Plantão Pessoal
                                    </button>
                                )}
                            </div>
                            <div className="row mt-4 mb-4">
                                <div className="col-md-4">
                                    <div className="form-group ">
                                        <label>Data</label>
                                        <div className="form-control">
                                            <RangePicker
                                                style={{border: "none", boxShadow: "none"}}
                                                locale={locale}
                                                format="DD/MM/YYYY"
                                                className="range-picker-custom"
                                                value={filters.dateRange.length > 0 ? filters.dateRange : null}
                                                onChange={(dates) => {
                                                    if (dates) {
                                                        handleSearchFiltersChange("dateRange", dates);
                                                        handleSearchFiltersChange("datestart", dayjs(dates[0]).format("YYYY-MM-DD"));
                                                        handleSearchFiltersChange("dateend", dayjs(dates[1]).format("YYYY-MM-DD"));
                                                    } else {
                                                        handleSearchFiltersChange("dateRange", []);
                                                        handleSearchFiltersChange("datestart", null);
                                                        handleSearchFiltersChange("dateend", null);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <HospitalSearch
                                        buttonAdd={false}
                                        cache={false}
                                        all={user?.users_type_id === 1}
                                        validateManager={true}
                                        onHospitalSelect={onHospitalSelect}
                                    />
                                </div>
                                {(checkManager || user?.users_type_id === 2) && (
                                    <div className="col-md-4 form-group">
                                        <UsersSearch
                                            ref={refUserSearch}
                                            onUserSelect={(user) =>
                                                setFilters((prevFilters) => ({
                                                    ...prevFilters,
                                                    user_id: user?.value || "",
                                                }))
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="row mt-4 mb-3">
                                <div className="col-md-12 d-flex justify-content-end">
                                    <button type="button" className="btn  mr-1  me-2"
                                            onClick={() => handleClearFilters()}>
                                        <i className="fa fa-eraser"></i> Limpar Filtros
                                    </button>
                                    <button type="button" className="btn btn-dark btn-s mr-1 me-2"
                                            onClick={() => fetchDuties(1, true, false)}>
                                        <i className="fas fa-file-excel"></i> Exportar
                                    </button>
                                    {(checkManager || user?.users_type_id === 2) && (
                                        <>
                                            <button type="button" className="btn btn-dark btn-s mr-1 me-2"
                                                    onClick={() => fetchDuties(1, true, true)}>
                                                <i className="fas fa-file-pdf"></i> Painel PDF
                                            </button>
                                            <button type="button" className="btn btn-warning btn-s mr-1 me-2"
                                                    onClick={() => handleMigrateUser()}>
                                                <i className="fa fa-exchange-alt"></i> Migrar Usuário
                                            </button>
                                        </>
                                    )}
                                    <button type="button"
                                            className="btn btn-success"
                                            onClick={() => fetchDuties(1, false, false)}
                                            disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Buscando...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-search me-2"></i> Buscar
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>

                            <Row className="gy-2 mb-2" id="candidate-list">
                                {loading ? (
                                    <>
                                        <div className="card duty-card shadow-sm mb-3">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-3">
                                                        <Skeleton width={150} height={150}/>
                                                    </div>
                                                    <div className="col-9">
                                                        <Skeleton width={200}/>
                                                        <p>
                                                            <Skeleton width={200}/>
                                                        </p>
                                                        <p className="card-text">
                                                            <Skeleton width={200}/>
                                                        </p>
                                                        <p className="card-text">
                                                            <Skeleton width={200}/>
                                                        </p>
                                                        <p className="card-text">
                                                            <Skeleton width={200}/>
                                                        </p>
                                                        <p className="card-text">
                                                            <Skeleton width={200}/>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    duties.length > 0 ? (
                                        duties.map((duty) => (
                                            <Col lg={12} key={duty.id}>
                                                <Card className="mb-2 p-1 shadow-sm card-hover duty-card">
                                                    <CardBody className="p-2">
                                                        <Row className="align-items-center">
                                                            {/* Coluna 1 - Checkbox */}
                                                            <Col xs={1} className="text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    className="checkbox-wrapper-23"
                                                                    checked={selectedIds.includes(duty.id)}
                                                                    onChange={() => handleCheckboxChange(duty.id)}
                                                                    style={{width: "16px", height: "16px"}}
                                                                />
                                                            </Col>

                                                            {/* Coluna 2 - Usuário + plantão */}
                                                            <Col xs={6} md={4}>
                                                                {duty.accept_user && (
                                                                    <div className="d-flex  mb-2">
                                                                        {duty.user_id !== user?.id && (
                                                                            <Avatar
                                                                                src={duty.accept_user.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                                                size={40}
                                                                                style={{
                                                                                    width: 40,
                                                                                    height: 40,
                                                                                    borderRadius: "50%",
                                                                                    objectFit: "cover",
                                                                                    marginRight: 8,
                                                                                }}
                                                                            />
                                                                        )}
                                                                        <div>
                                                                            <strong className="d-block">
                                                                                {duty.id_user_accepted === user?.id ? "Meu Plantão" : duty.accept_user.name}
                                                                            </strong>

                                                                            <small className="text-muted">
                                                                                <i className="fa fa-map-marker-alt me-1 text-info"></i>
                                                                                {duty.hospital?.city?.name}, {duty.hospital?.uf}
                                                                            </small>
                                                                            <p className="mb-1">
                                                                                <i className="fa fa-tag me-1 text-info"></i>
                                                                                {duty.id}
                                                                            </p>
                                                                            {duty?.accept_user_origin?.id !== duty?.accept_user?.id && (
                                                                            <p className="mb-1" title="Original da Escala">
                                                                                <i className="fa fa-user me-1 text-info"></i>
                                                                                {duty?.accept_user_origin?.name}
                                                                            </p>
                                                                            )}
                                                                            <p className="mb-1">
                                                                                <i className="fa fa-building text-info me-1"></i>
                                                                                {duty.department?.name || "Departamento não informado"}
                                                                            </p>
                                                                            <p className="mb-1">
                                                                                <i className="fa fa-clock text-info me-1"></i>
                                                                                {calculateDuration(duty.date_time, duty.date_time_end)}
                                                                            </p>
                                                                            <div>
                                                                                {duty.specialties?.map((s) => (
                                                                                    <Tag key={s.id} color="blue"
                                                                                         style={{fontSize: "0.75rem"}}>
                                                                                        {s.name}
                                                                                    </Tag>
                                                                                ))}
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                )}

                                                            </Col>

                                                            {/* Coluna 3 - Datas e valor */}
                                                            <Col xs={6} md={3}>
                                                                <p className="text-muted mb-1">
                                                                    <i className="fa fa-calendar text-info me-1"></i>
                                                                    {new Date(duty.date_time).toLocaleDateString("pt-BR")}{" "}
                                                                    {new Date(duty.date_time).toLocaleTimeString("pt-BR", {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}
                                                                </p>
                                                                <p className="text-muted mb-2">
                                                                    <i className="fa fa-calendar text-info me-1"></i>
                                                                    {new Date(duty.date_time_end).toLocaleDateString("pt-BR")}{" "}
                                                                    {new Date(duty.date_time_end).toLocaleTimeString("pt-BR", {
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                    })}
                                                                </p>
                                                                <p className="text-success fw-bold mb-0">
                                                                    {new Intl.NumberFormat("pt-BR", {
                                                                        style: "currency",
                                                                        currency: "BRL",
                                                                    }).format(duty.value)}
                                                                </p>
                                                            </Col>

                                                            {/* Coluna 4 - Hospital */}
                                                            <Col xs={12} md={2} className="text-center">
                                                                <div
                                                                    className="d-flex flex-column align-items-center ml-2">
                                                                    <Avatar
                                                                        src={
                                                                            duty.hospital?.images?.[0]?.file ||
                                                                            `${process.env.REACT_APP_URL_STORAGE}src/hospital_icone.png`
                                                                        }
                                                                        size={40}
                                                                        style={{
                                                                            width: 40,
                                                                            height: 40,
                                                                            borderRadius: "50%",
                                                                            objectFit: "cover",
                                                                            backgroundColor: "#f0f0f0",
                                                                            marginBottom: 4,
                                                                        }}
                                                                    />
                                                                    <strong
                                                                        className="text-center"
                                                                        style={{fontSize: "11px", lineHeight: "1.1"}}
                                                                    >
                                                                        {duty.hospital?.name?.split(" ").slice(0, 4).join(" ")}
                                                                    </strong>
                                                                    <small className="text-muted"
                                                                           style={{fontSize: "10px"}}>
                                                                        {duty.hospital?.name?.split(" ").slice(4).join(" ")}
                                                                    </small>
                                                                </div>
                                                            </Col>

                                                            {/* Coluna 5 - Botões de ação */}
                                                            <Col xs={12} md={2}
                                                                 className="text-end  d-flex flex-column align-items-end justify-content-center">
                                                                {/* Botões de ação com controle de visibilidade */}


                                                                {(duty.user_id === user?.id && user?.users_type_id === 1) ? (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-dark btn-sm ms-1 mb-2 w-100"
                                                                        onClick={() => handleModalPersonalOpen(duty)}
                                                                    >
                                                                        <i className="fa fa-edit"></i> Editar Pessoal
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-dark btn-sm ms-1 mb-2 w-100"
                                                                        onClick={() => handleModalOpen(duty)}
                                                                    >
                                                                        <i className="fa fa-edit"></i> Editar
                                                                    </button>
                                                                )}


                                                                {duty?.scale_id == null && (
                                                                    <button type="button"
                                                                            className="btn btn-outline-danger btn-sm me-0 mb-2 w-100"
                                                                            onClick={() => handleDelete(duty.id)}
                                                                    >
                                                                        <i className="fa fa-close"></i> Deletar
                                                                    </button>
                                                                )}

                                                                {(duty.active === 1 && !duty.accept?.some(item => item.status === 'reposting')) && (
                                                                    <button type="button"
                                                                            className="btn btn-primary  btn-sm me-0 w-100"
                                                                            onClick={() => handleSelectPlantonistaOpen(duty)}
                                                                            title={
                                                                                !duty.interested_user || duty.interested_user.length === 0
                                                                                    ? "Nenhum plantonista interessado disponível para seleção."
                                                                                    : ""
                                                                            }
                                                                    >
                                                                        <i className="fa fa-user me-1"></i> Plantonistas
                                                                    </button>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        ))
                                    ) : (
                                        <div className=" duty-card shadow-sm mb-3">
                                            <div className="alert alert-primary" role="alert">Nenhum plantão
                                                encontrado.

                                            </div>
                                        </div>
                                    )
                                )}
                            </Row>
                            <CustomPagination
                                className="mt-4"
                                pagination={pagination}
                                onChange={(page) => fetchDuties(page, false, false)}
                            />

                        </div>


                        <PlantaoModal
                            show={modalVisible}
                            handleClose={handleModalClose}
                            handleSubmit={fetchDuties}
                            duty={selectedDuty}
                        />

                        <PlantaoPersonalModal
                            show={modalPersonalVisible}
                            handleClose={handleModalPersonalClose}
                            handleSubmit={fetchDuties}
                            duty={selectedDuty}
                        />
                        <SelectPlantonistaModal
                            show={selectPlantonistaVisible}
                            handleClose={handleSelectPlantonistaClose}
                            duty={selectedDuty}
                            // onPlantonistaSelected={fetchDuties}
                        />
                        <ImportModal
                            show={showImportModal}
                            onHide={handleHideImportModal}
                            initialData={docTypeModalData}
                            importType={2}
                        />
                        {showSelectedModal && (
                            <DutyMigrateUserModal
                                show={showSelectedModal}
                                arraySelect={arrayDutySelected}
                                handleClose={handleSelectedModalClose}
                            />
                        )}

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Duty;
